import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import {api, Callable} from '@/Api';
import * as moment from 'moment';
import 'moment/locale/fr';
import {helper} from "./Utils/Helper";
import {Route} from 'vue-router';

import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);


Vue.config.productionTip = false;
// console.log(process.env.NODE_ENV);
if (process.env.NODE_ENV === 'production') {
    window.console.log = function () {
        return null;
    };
}



router.beforeEach((to, from, next: Callable) => {
    // if ( process.env.VUE_APP_ENV == 'prod') {
    //     const newLocation = window.location.href.replace(window.location.host, process.env.VUE_APP_V1_HOST);
    //     window.location.replace(newLocation);
    // }
    api.init(next);
});
router.afterEach((to: Route, from: Route) => {
    if(to.query.hasOwnProperty('splash_message') && parseInt(to.query.splash_message + '', 10) === 1 && store.state.splashDisplayed === false) {
        store.commit('openModal', {type: 'splash-message'});
    }
});

Vue.prototype.readableDate = helper.readable;
Vue.filter('round', Math.round);
new Vue({
    router,
    store,
    render: (h) => h(App),
}).$mount('#app');
